const defaultItems = [
	{
		"id": "ysq-l3-001",
		"text": "People have not been there to meet my emotional needs.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-002",
		"text": "I haven't gotten enough love and attention.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-003",
		"text": "For the most part, I haven't had someone to depend on for advice and emotional support.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-004",
		"text": "Most of the time, I haven't had someone to nurture me, share him/herself with me, or care deeply about everything that happens to me.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-005",
		"text": "For much of my life, I haven't had someone who wanted to get close to me and spend a lot of time with me.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-006",
		"text": "In general, people have not been there to give me warmth, holding, and affection.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-007",
		"text": "For much of my life, I haven't felt that I am special to someone.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-008",
		"text": "For the most part, I have not had someone who really listens to me, understands me, or is tuned into my true needs and feelings.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-009",
		"text": "I have rarely had a strong person to give me sound advice or direction when I'm not sure what to do.",
		"modeIds": [
			"ed"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-010",
		"text": "I worry that the people I love will die soon, even though there is little medical reason to support my concern.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-011",
		"text": "I find myself clinging to people I'm close to, because I'm afraid they'll leave me.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-012",
		"text": "I worry that people I feel close to will leave me or abandon me.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-013",
		"text": "I feel that I lack a stable base of emotional support.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-014",
		"text": "I don't feel that important relationships will last; I expect them to end.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-015",
		"text": "I feel addicted to partners who can't be there for me in a committed way.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-016",
		"text": "In the end, I will be alone.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-017",
		"text": "When I feel someone I care for pulling away from me, I get desperate.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-018",
		"text": "Sometimes I am so worried about people leaving me that I drive them away.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-019",
		"text": "I become upset when someone leaves me alone, even for a short period of time.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-020",
		"text": "I can't count on people who support me to be there on a regular basis.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-021",
		"text": "I can't let myself get really close to other people, because I can't be sure they'll always be there.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-022",
		"text": "It seems that the important people in my life are always coming and going.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-023",
		"text": "I worry a lot that the people I love will find someone else they prefer and leave me.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-024",
		"text": "The people close to me have been very unpredictable: one moment they're available and nice to me; the next, they're angry, upset, self-absorbed, fighting, etc.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-025",
		"text": "I need other people so much that I worry about losing them.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-026",
		"text": "I can't be myself or express what I really feel, or people will leave me.",
		"modeIds": [
			"ab"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-027",
		"text": "I feel that people will take advantage of me.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-028",
		"text": "I often feel that I have to protect myself from other people.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-029",
		"text": "I feel that I cannot let my guard down in the presence of other people, or else they will intentionally hurt me.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-030",
		"text": "If someone acts nicely towards me, I assume that he/she must be after something.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-031",
		"text": "It is only a matter of time before someone betrays me.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-032",
		"text": "Most people only think about themselves.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-033",
		"text": "I have a great deal of difficulty trusting people.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-034",
		"text": "I am quite suspicious of other people's motives.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-035",
		"text": "Other people are rarely honest; they are usually not what they appear.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-036",
		"text": "I'm usually on the lookout for people's ulterior motives.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-037",
		"text": "If I think someone is out to hurt me, I try to hurt him or her first.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-038",
		"text": "People usually have to prove themselves to me before I can trust them.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-039",
		"text": "I set up \"tests\" for other people, to see if they are telling me the truth and are well- intentioned.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-040",
		"text": "I subscribe to the belief: \"Control or be controlled.\"",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-041",
		"text": "I get angry when I think about the ways I have been mistreated by other people during my life.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-042",
		"text": "During my life, those close to me have taken advantage of me or used me for their own purposes.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-043",
		"text": "I have been physically, emotionally, or sexually abused by important people in my life.",
		"modeIds": [
			"ma"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-044",
		"text": "I don't fit in.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-045",
		"text": "I'm fundamentally different from other people.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-046",
		"text": "I don't belong; I'm a loner.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-047",
		"text": "I feel alienated from other people.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-048",
		"text": "I feel isolated and alone.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-049",
		"text": "I always feel on the outside of groups.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-050",
		"text": "No one really understands me.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-051",
		"text": "My family was always different from the families around us.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-052",
		"text": "I sometimes feel as if I'm an alien.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-053",
		"text": "If I disappeared tomorrow, no one would notice.",
		"modeIds": [
			"si"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-054",
		"text": "No man/woman I desire could love me once he/she saw my defects.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-055",
		"text": "No one I desire would want to stay close to me if he/she knew the real me.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-056",
		"text": "I am inherently flawed and defective.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-057",
		"text": "No matter how hard I try, I feel that I won't be able to get a significant man/woman to respect me or feel that I am worthwhile.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-058",
		"text": "I'm unworthy of the love, attention, and respect of others.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-059",
		"text": "I feel that I'm not lovable.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-060",
		"text": "I am too unacceptable in very basic ways to reveal myself to other people.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-061",
		"text": "If others found out about my basic defects, I could not face them.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-062",
		"text": "When people like me, I feel I am fooling them.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-063",
		"text": "I often find myself drawn to people who are very critical of me or reject me.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-064",
		"text": "I have inner secrets that I don't want people close to me to find out.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-065",
		"text": "It is my fault that my parent(s) could not love me enough.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-066",
		"text": "I don't let people know the real me.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-067",
		"text": "One of my greatest fears is that my defects will be exposed.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-068",
		"text": "I cannot understand how anyone could love me.",
		"modeIds": [
			"ds"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-069",
		"text": "Almost nothing I do at work (or school) is as good as other people can do.",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-070",
		"text": "I'm incompetent when it comes to achievement.",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-071",
		"text": "Most other people are more capable than I am in areas of work (or school) and achievement.",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-072",
		"text": "I'm a failure.",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-073",
		"text": "I'm not as talented as most people are at their work (or at school).",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-074",
		"text": "I'm not as intelligent as most people when it comes to work (or school).",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-075",
		"text": "I am humiliated by my failures and inadequacies in the work (or school) sphere.",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-076",
		"text": "I often feel embarrassed around other people, because I don't measure up to them in terms of my accomplishments.",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-077",
		"text": "I often compare my accomplishments with others and feel that they are much more successful.",
		"modeIds": [
			"fa"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-078",
		"text": "I do not feel capable of getting by on my own in everyday life.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-079",
		"text": "I need other people to help me get by.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-080",
		"text": "I do not feel I can cope well by myself.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-081",
		"text": "I believe that other people can take of me better than I can take care of myself.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-082",
		"text": "I have trouble tackling new tasks outside of work, unless I have someone to guide me.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-083",
		"text": "I think of myself as a dependent person when it comes to everyday functioning.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-084",
		"text": "I screw up everything I try, even outside of work (or school).",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-085",
		"text": "I'm inept in most areas of life.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-086",
		"text": "If I trust my own judgment in everyday situations, I'll make the wrong decision.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-087",
		"text": "I lack common sense.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-088",
		"text": "My judgment cannot be relied on in everyday situations.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-089",
		"text": "I don't feel confident about my ability to solve everyday problems that come up.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-090",
		"text": "I feel that I need someone I can rely on to give me advice about practical issues.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-091",
		"text": "I feel more like a child than an adult when it comes to handling everyday responsibilities.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-092",
		"text": "I find the responsibilities of everyday life overwhelming.",
		"modeIds": [
			"di"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-093",
		"text": "I can't seem to escape the feeling that something bad is about to happen.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-094",
		"text": "I feel that a disaster (natural, criminal, financial, or medical) could strike at any moment.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-095",
		"text": "I worry about becoming a street person or vagrant.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-096",
		"text": "I worry about being attacked.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-097",
		"text": "I take great precautions to avoid getting sick or hurt.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-098",
		"text": "I worry that I'm developing a serious illness, even though nothing serious has been diagnosed by a physician.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-099",
		"text": "I am a fearful person.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-100",
		"text": "I worry a lot about the bad things happening in the world: crime, pollution, etc.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-101",
		"text": "I often feel that I might go crazy.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-102",
		"text": "I often feel that I'm going to have an anxiety attack.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-103",
		"text": "I often worry that I might have a heart attack or cancer, even though there is little medical reason to be concerned.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-104",
		"text": "I feel that the world is a dangerous place.",
		"modeIds": [
			"vu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-105",
		"text": "I have not been able to separate myself from my parent(s), the way other people my age seem to.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-106",
		"text": "My parent(s) and I tend to be overinvolved in each other's lives and problems.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-107",
		"text": "It is very difficult for my parent(s) and me to keep intimate details from each other, without feeling betrayed or guilty.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-108",
		"text": "My parent(s) and I have to speak to each other almost every day, or else one of us feels guilty, hurt, disappointed, or alone.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-109",
		"text": "I often feel that I do not have a separate identity from my parents or partner.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-110",
		"text": "I often feel as if my parent(s) are living through me -- I don't have a life of my own.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-111",
		"text": "It is very difficult for me to maintain any distance from the people I am intimate with; I have trouble keeping any separate sense of myself.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-112",
		"text": "I am so involved with my partner or parent(s) that I do not really know who I am or what I want.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-113",
		"text": "I have trouble separating my point of view or opinion from that of my parent(s) or partner.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-114",
		"text": "I often feel that I have no privacy when it comes to my parent(s) or partner.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-115",
		"text": "I feel that my parent(s) are, or would be, very hurt about my living on my own, away from them.",
		"modeIds": [
			"eu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-116",
		"text": "I let other people have their way, because I fear the consequences.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-117",
		"text": "I believe that if I do what I want, I'm only asking for trouble.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-118",
		"text": "I feel that I have no choice but to give in to other people’s wishes, or else they will retaliate or reject me in some way.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-119",
		"text": "In relationships, I let the other person have the upper hand.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-120",
		"text": "I've always let others make choices for me, so I really don't know what I want for myself.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-121",
		"text": "I feel the major decisions in my life were not really my own.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-122",
		"text": "I worry a lot about pleasing other people, so they won't reject me.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-123",
		"text": "I have a lot of trouble demanding that my rights be respected and that my feelings be taken into account.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-124",
		"text": "I get back at people in little ways instead of showing my anger directly.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-125",
		"text": "I will go to much greater lengths than most people to avoid confrontations.",
		"modeIds": [
			"sb"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-126",
		"text": "I put others' needs before my own, or else I feel guilty.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-127",
		"text": "I feel guilty when I let other people down or disappoint them.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-128",
		"text": "I give more to other people than I get back in return.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-129",
		"text": "I'm the one who usually ends up taking care of the people I'm close to.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-130",
		"text": "There is almost nothing I couldn't put up with if I loved someone.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-131",
		"text": "I am a good person because I think of others more than of myself.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-132",
		"text": "At work, I'm usually the one to volunteer to do extra tasks or to put in extra time.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-133",
		"text": "No matter how busy I am, I can always find time for others.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-134",
		"text": "I can get by on very little, because my needs are minimal.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-135",
		"text": "I'm only happy when those around me are happy.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-136",
		"text": "I'm so busy doing for the people that I care about that I have little time for myself.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-137",
		"text": "I've always been the one who listens to everyone else's problems.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-138",
		"text": "I'm more comfortable giving a present than receiving one.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-139",
		"text": "Other people see me as doing too much for others and not enough for myself.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-140",
		"text": "No matter how much I give, I feel it is never enough.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-141",
		"text": "If I do what I want, I feel very uncomfortable.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-142",
		"text": "It's very difficult for me to ask others to take care of my needs.",
		"modeIds": [
			"ss"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-143",
		"text": "I worry about losing control of my actions.",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-144",
		"text": "I worry that I might seriously harm someone physically or emotionally, if my anger gets out of control.",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-145",
		"text": "I feel that I must control my emotions and impulses, or something bad is likely to happen.",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-146",
		"text": "A lot of anger and resentment build up inside of me that I don't express.",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-147",
		"text": "I am too self-conscious to show positive feelings to others (e.g., affection, showing I care).",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-148",
		"text": "I find it embarrassing to express my feelings to others.",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-149",
		"text": "I find it hard to be warm and spontaneous.",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-150",
		"text": "I control myself so much that people think I am unemotional.",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-151",
		"text": "People see me as uptight emotionally.",
		"modeIds": [
			"ei"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-152",
		"text": "I must be the best at most of what I do; I can't accept second best.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-153",
		"text": "I strive to keep almost everything in perfect order.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-154",
		"text": "I must look my best most of the time.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-155",
		"text": "I try to do my best; I can't settle for \"good enough.\"",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-156",
		"text": "I have so much to accomplish that there is almost no time to really relax.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-157",
		"text": "Almost nothing I do is quite good enough; I can always do better.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-158",
		"text": "I must meet all my responsibilities.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-159",
		"text": "I feel there is constant pressure for me to achieve and get things done.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-160",
		"text": "My relationships suffer because I push myself so hard.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-161",
		"text": "My health is suffering because I put myself under so much pressure to do well.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-162",
		"text": "I often sacrifice pleasure and happiness to meet my own standards.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-163",
		"text": "When I make a mistake, I deserve strong criticism.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-164",
		"text": "I can't let myself off the hook easily or make excuses for my mistakes.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-165",
		"text": "I'm a very competitive person.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-166",
		"text": "I put a good deal of emphasis on money or status.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-167",
		"text": "I always have to be Number One, in terms of my performance.",
		"modeIds": [
			"us"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-168",
		"text": "I have a lot of trouble accepting \"no\" for an answer when I want something from other people.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-169",
		"text": "I often get angry or irritable if I can't get what I want.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-170",
		"text": "I'm special and shouldn't have to accept many of the restrictions placed on other people.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-171",
		"text": "I hate to be constrained or kept from doing what I want.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-172",
		"text": "I feel that I shouldn't have to follow the normal rules and conventions other people do.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-173",
		"text": "I feel that what I have to offer is of greater value than the contributions of others.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-174",
		"text": "I usually put my needs ahead of the needs of others.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-175",
		"text": "I often find that I am so involved in my own priorities that I don't have time to give to friends or family.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-176",
		"text": "People often tell me I am very controlling about the ways things are done.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-177",
		"text": "I get very irritated when people won't do what I ask of them.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-178",
		"text": "I can't tolerate other people telling me what to do.",
		"modeIds": [
			"et"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-179",
		"text": "I have great difficulty getting myself to stop drinking, smoking, overeating, or other problem behaviors.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-180",
		"text": "I can't seem to discipline myself to complete routine or boring tasks.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-181",
		"text": "Often I allow myself to carry through on impulses and express emotions that get me into trouble or hurt other people.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-182",
		"text": "If I can't reach a goal, I become easily frustrated and give up.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-183",
		"text": "I have a very difficult time sacrificing immediate gratification to achieve a long-range goal.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-184",
		"text": "It often happens that, once I start to feel angry, I just can't control it.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-185",
		"text": "I tend to overdo things, even though I know they are bad for me.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-186",
		"text": "I get bored very easily.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-187",
		"text": "When tasks become difficult, I usually cannot persevere and complete them.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-188",
		"text": "I can't concentrate on anything for too long.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-189",
		"text": "I can't force myself to do things I don't enjoy, even when I know it's for my own good.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-190",
		"text": "I lose my temper at the slightest offense.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-191",
		"text": "I have rarely been able to stick to my resolutions.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-192",
		"text": "I can almost never hold back from showing people how I really feel, no matter what the cost may be.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-193",
		"text": "I often do things impulsively that I later regret.",
		"modeIds": [
			"is"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-194",
		"text": "It is important to me to be liked by almost everyone I know.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-195",
		"text": "I change myself depending on the people I’m with, so they’ll like me more.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-196",
		"text": "I try hard to fit in.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-197",
		"text": "My self-esteem is based mostly on how other people view me.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-198",
		"text": "Having money and knowing important people make me feel worthwhile.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-199",
		"text": "I spend a lot of time on my physical appearance so people will value me.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-200",
		"text": "Accomplishments are most valuable to me if other people notice them.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-201",
		"text": "I am so focused on fitting in that sometimes I don’t know who I am.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-202",
		"text": "I find it hard to set my own goals, without taking into account how others will respond to my choices.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-203",
		"text": "When I look at my life decisions, I see that I made most of them with other people’s approval in mind.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-204",
		"text": "Even if I don’t like someone, I still want him or her to like me.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-205",
		"text": "Unless I get a lot of attention from others, I feel less important.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-206",
		"text": "If I make remarks at a meeting or am introduced at a gathering, I look forward to recognition and admiration.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-207",
		"text": "Lots of praise and compliments make me feel like a worthwhile person.",
		"modeIds": [
			"as"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-208",
		"text": "Even when things seem to be going well, I feel that it is only temporary.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-209",
		"text": "If something good happens, I worry that something bad is likely to follow.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-210",
		"text": "You can’t be too careful; something will almost always go wrong.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-211",
		"text": "No matter how hard I work, I worry that I could be wiped out financially.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-212",
		"text": "I worry that a wrong decision could lead to disaster.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-213",
		"text": "I often obsess over minor decisions, because the consequences of making a mistake seem so serious.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-214",
		"text": "I feel better assuming that things will not work out for me, so that I don’t feel disappointed if things go wrong.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-215",
		"text": "I focus more on the negative aspects of life and of events than on the positive.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-216",
		"text": "I tend to be pessimistic.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-217",
		"text": "People close to me consider me a worrier.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-218",
		"text": "If people get too enthusiastic about something, I become uncomfortable and feel like warning them of what could go wrong.",
		"modeIds": [
			"np"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-219",
		"text": "If I make a mistake, I deserve to be punished.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-220",
		"text": "If I don’t try my hardest, I should expect to lose out.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-221",
		"text": "There is no excuse if I make mistake.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-222",
		"text": "People who don’t “pull their own weight” should get punished in some way.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-223",
		"text": "Most of the time, I don’t accept the excuses other people make. They’re just not willing to accept responsibility and pay the consequences.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-224",
		"text": "If I don’t do the job, I should suffer the consequences.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-225",
		"text": "I often think about mistakes I’ve made and feel angry with myself.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-226",
		"text": "When people do something bad, I have trouble applying the phrase, “Forgive and forget”.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-227",
		"text": "I hold grudges, even after someone has apologized.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-228",
		"text": "I get upset when I think someone has been “let off the hook” too easily.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-229",
		"text": "I get angry when people make excuses for themselves, or blame other people for their problems.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-230",
		"text": "It doesn’t matter why I make a mistake; when I do something wrong, I should pay the price.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-231",
		"text": "I “beat up” on myself a lot for things I screw up.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	},
	{
		"id": "ysq-l3-232",
		"text": "I’m a bad person who deserves to be punished.",
		"modeIds": [
			"pu"
		],
		"weight": 1
	}
]

const defaultSchemas = [
	{
		"id": "ed",
		"title": "Emotional Deprivation",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "ab",
		"title": "Abandonment",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	},
	{
		"id": "ma",
		"title": "Mistrust/Abuse",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	},
	{
		"id": "si",
		"title": "Social Isolation",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "ds",
		"title": "Defectiveness",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	},
	{
		"id": "fa",
		"title": "Failure",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "di",
		"title": "Dependence",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	},
	{
		"id": "vu",
		"title": "Vulnerability",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "eu",
		"title": "Enmeshment",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "sb",
		"title": "Subjugation",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "ss",
		"title": "Self-Sacrifice",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	},
	{
		"id": "ei",
		"title": "Emotional Inhibition",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "us",
		"title": "Unrelenting Standards",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	},
	{
		"id": "et",
		"title": "Entitlement",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "is",
		"title": "Insuf. Self-Control",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	},
	{
		"id": "as",
		"title": "Approval-Seeking",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	},
	{
		"id": "np",
		"title": "Negativity/Pessimism",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			8,
			18,
			30
		]
	},
	{
		"id": "pu",
		"title": "Punitiveness",
		"group": "Early maladaptive schemas",
		"description": "",
		"bandUpper": [
			12,
			25,
			39
		]
	}
]

export function createYoungSchemaQuestionnaireL3Config() {
	return {
		title: "Young Schema Questionnaire — Long Form, 3rd Edition (YSQ-L3)",
		subscaleProfile: {
			versionLabel: "YSQ-L3, 232-item questionnaire",
			versionDescription: "A comprehensive profile of 18 early maladaptive schemas.",
			instructions: "Read each statement and decide how well it describes you. When you are unsure, base your answer on what you emotionally feel rather than what you think to be true. If useful, reword a statement so it describes you more accurately without changing its basic meaning. Choose the highest rating from 1 to 6 that describes you, including your revisions.",
			interpretationText: "Scores count ratings of 4 or higher. Grid categories describe the scored profile; discuss the results alongside clinical information.",
			purpose: "Case conceptualization",
			dueDate: "",
			monitoring: true,
			selectComparisons: true,
			ratingMin: 1,
			ratingMax: 6,
			anchors: ["Completely untrue of me", "Mostly untrue of me", "Slightly more true than untrue", "Moderately true of me", "Mostly true of me", "Describes me perfectly"].map((title, index) => ({id: `ysq-rating-${index + 1}`, title, value: index + 1})),
			scoringMethod: "thresholdSum",
			scoringThreshold: 4,
			subjectLabel: "Schema",
			items: JSON.parse(JSON.stringify(defaultItems)),
			modes: JSON.parse(JSON.stringify(defaultSchemas)),
		},
		fields: [],
	}
}

export function createYoungSchemaQuestionnaireL3DemoPayload() {
	const config = createYoungSchemaQuestionnaireL3Config()
	const answers = Object.fromEntries(config.subscaleProfile.items.map((item, index) => [item.id, `ysq-rating-${index % 6 + 1}`]))
	return {form: config, answers, administrationDate: "2026-10-21"}
}
